/**
 * @desc 查询合作企业
 */
import { BrandEntity, BrandParam } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBrandListParameter = BrandParam

const method = 'GET'
const url = '/content/mall/brand/list'

export const queryBrandListApi = (
  params?: QueryBrandListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<BrandEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryBrandListApi.method = method
queryBrandListApi.url = url
